//* import statements
import React, {
  useState,
  useEffect,
} from "react";
import axios from "axios";
export const AuthContext = React.createContext({
  tours: [],
  isLoading: false,
  error: {},
  onRefreshTours: () => {},
  onDeleteTour:()=>{}
});
const uri =
  "https://course-api.com/react-tours-project";

export const AuthContextProvider = (props) => {
  const [tours, setTours] = useState([]);
  const [isLoading, setIsLoading] =
    useState(true);
  const [error, setError] = useState({
    hasError: null,
    errorName: "",
  });
  //? functions
  const deleteTourHandler = (id) => {
    const newTour = tours.filter(
      (tour) => tour.id !== id
    );
    setTours(newTour);
  };
  const refreshToursHandler = () => {
    setIsLoading(true);
    fetchData();
  };
  const fetchData = async () => {
    try {
      const { data } = await axios.get(uri);
      setError((prevError) => {
        return { ...prevError, hasError: false };
      });
      setTours(data);
    } catch (error) {
      setError((prevError) => {
        return {
          ...prevError,
          hasError: true,
          errorName: error.message,
        };
      });
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const value = {
    tours,
    isLoading,
    error,
    onRefreshTours: refreshToursHandler,
    onDeleteTour:deleteTourHandler
  };
  return (
    <AuthContext.Provider value={value}>
      {props.children}
    </AuthContext.Provider>
  );
};
